import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorkReportMeasuresApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORK_REPORT_MEASURES, {
			entity: 'work_report_measures',
		})
	}
}
